import styled from "styled-components";

export const ConfirmationModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ConfirmModalActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
`;